import template from './faq.html';
import controller from './faq.controller';

let faqComponent = {
  bindings: {},
  template,
  controller
};

export default faqComponent;



// WEBPACK FOOTER //
// ./client/app/components/faq/faq.component.js